import ga4 from '../lib/ga-helper.js'
import '../lib/readingtime.js'

$(() => {
  $('.js-page-readtime').readingTime({
    readingTimeTarget: $('.time-to-read > .ttr-target'),
    lessThanAMinuteString: '1 min',
    wordsPerMinute: 200
  })
  grecaptcha.ready(function() {
    grecaptcha.execute('6LfnK48UAAAAAHI21G_zmOWYDTv0n1VABrlq8MkJ', {
      action: 'campaignpage'
    })
    .then(function(token) {
      $('.js-recaptcha').val(token);
    });
  });
  const $captCallout = $('.js-lead-callout');
  $captCallout.on('click', function(){
    ga4.trackEvnt('Campaign page', $(this).data('action'),$(this).data('label'));
  });
  const $captForm = $('.js-lead-capture');
  new Foundation.Abide($captForm);
  $captForm.on('formvalid.zf.abide', function () {
      var data = $captForm.serialize();
      var submit = $captForm.find('.submit');
      var submitText = submit.html();
      submit.prop('disabled', true);
      submit.html('Sending ...');
			ga4.trackEvnt('Campaign page', $(this).data('action'),$(this).data('label'));
      $.ajax({
          type: 'POST',
          url: $captForm.data('post-endpoint') + 'verify_recaptcha',
          data: { 'g-recaptcha-response' : $('.js-recaptcha').val() } ,
          dataType: 'json'
      }).done(function(msg) {
          if (typeof(msg.success) != 'undefined' && msg.success == true) {
            $.ajax({
                type: 'POST',
                url: $captForm.data('post-endpoint') + 'submitForm',
                data: data,
                dataType: 'json'
            }).done(function (msg) {
                if (typeof (msg.success) != 'undefined' && msg.success == true) {
                  $captForm.find('.js-form').fadeOut(400,function(){
                    $('html,body').animate({
                      scrollTop: ($captForm.offset().top - 76)
                    }, 500);
                    $captForm.find('.js-results').fadeIn(400);
                  });
                  grecaptcha.execute('6LfnK48UAAAAAHI21G_zmOWYDTv0n1VABrlq8MkJ', {
                    action: 'campaignpage'
                  })
                  .then(function(token) {
                    $('.js-recaptcha').val(token);
                  });
                }
            }).fail(function (msg) {
                console.log(msg);
                alert('there has been an error, please retry');
            }).always(function () {
                submit.prop('disabled', false);
                submit.html(submitText);
            });
          }
      });
  }).on('submit', function (evt) {
      evt.preventDefault()
  })
})
